import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useCasinoUi } from '../../context/CasinoUiContext'
import { buildCasinoSlotsPlayTarget } from '../../utils/lotusCasinoPlay'

export type LotusCasinoPlayRouterProps = {
  /** Fallback provider category when the game record has none */
  defaultCategory?: string | null
  preLoginMode?: boolean
  onLoginRequired?: () => void
}

/**
 * Routes Lotus UI play clicks to /casino-int/slots?category=… with openGame state
 * (same path as home, trending, and provider pages).
 */
const LotusCasinoPlayRouter: React.FC<LotusCasinoPlayRouterProps> = ({
  defaultCategory,
  preLoginMode = false,
  onLoginRequired,
}) => {
  const navigate = useNavigate()
  const { registerPlayHandler } = useCasinoUi()

  useEffect(() => {
    registerPlayHandler((game) => {
      if (preLoginMode) {
        onLoginRequired?.()
        return
      }
      const record = game as Record<string, unknown>
      const target = buildCasinoSlotsPlayTarget(record, { category: defaultCategory })
      navigate(
        { pathname: target.pathname, search: target.search },
        { state: target.state },
      )
    })
    return () => registerPlayHandler(null)
  }, [defaultCategory, navigate, onLoginRequired, preLoginMode, registerPlayHandler])

  return null
}

export default LotusCasinoPlayRouter
